import cx from 'classnames';
import IconButton from 'features/targetingV2/components/core/IconButton';
import List from 'features/targetingV2/components/core/List';
import StyledButton, {
  ButtonColorEnum,
  ButtonVariantEnum,
} from 'features/targetingV2/components/core/StyledButton';
import Typography from 'features/targetingV2/components/core/Typography';
import React from 'react';
import shortid from 'shortid';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';

import useStyles from './ErrorDialog.styles';

interface IErrorDialog {
  name: string;
  isOpen: boolean;
  handleClose: () => void;
  handleContinue?: () => void;
  errorMessages: string[];
  content: {
    title: string;
    closeButton: string;
    continueButton?: string;
  };
}

const ErrorDialog = ({
  name,
  isOpen,
  handleClose,
  errorMessages,
  handleContinue,
  content: { title, closeButton, continueButton },
}: IErrorDialog) => {
  const classes = useStyles({});
  const showContinueButton = !!(handleContinue && continueButton);

  return (
    <Dialog open={isOpen} onClose={handleClose} data-testid={`${name}Dialog`}>
      <DialogTitle classes={{ root: classes.title }} disableTypography>
        <Typography display="inline">{title}</Typography>
        <IconButton
          onClick={handleClose}
          classes={{ root: classes.closeButton }}
        >
          <CloseIcon />
          <span className="sr-only">Close the dialog</span>
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: classes.content }}>
        <List>
          {errorMessages.map((error: string) => (
            <li key={shortid.generate()} className={classes.errorMessage}>
              {error}
            </li>
          ))}
        </List>
      </DialogContent>
      <DialogActions
        classes={{
          root: cx(classes.actions, {
            [`${classes.actions}--space-between`]: showContinueButton,
          }),
        }}
      >
        <StyledButton
          onClick={handleClose}
          color={ButtonColorEnum.Primary}
          variant={ButtonVariantEnum.Outlined}
        >
          {closeButton}
        </StyledButton>
        {showContinueButton && (
          <StyledButton
            onClick={handleContinue as () => void}
            color={ButtonColorEnum.Primary}
            variant={ButtonVariantEnum.Contained}
          >
            {continueButton}
          </StyledButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
